export const badgeStatus = {
  ACTIVE: {
    background: "#27dd8b",
    color: "#000000"
  },
  IN_PROGRESS: {
    background: "#ffc82c",
    color: "#000000"
  },
  SUCCESS: {
    background: "#96ffa8",
    color: "#339865"
  },
  NOTICE: {
    background: "#d18cff",
    color: "#9900ff"
  },
  FINISHED: {
    background: "#1e1f46",
    color: "#ffffff"
  },
  WAITING_FOR_APPROVAL: {
    background: "#1e22ff",
    color: "#ffffff"
  },
  SCHEDULED: {
    background: "#667efe",
    color: "#ffffff"
  },
  ERROR: {
    background: "#ff357f",
    color: "#ffffff"
  },
  FULLFILLED: {
    background: "#ffffff",
    color: "#000000"
  },
  PREVIEW: {
    background: "#0000ff",
    color: "#ffffff"
  },
  DRAFT: {
    background: "#c3ffe4",
    color: "#000000"
  },
  REJECTED: {
    background: "#ff5b3c",
    color: "#ffffff"
  },
  PAUSED: {
    background: "#dceaff",
    color: "#000000"
  },
  CANCELLED: {
    background: "#ffbcaf",
    color: "#000000"
  }
};
